import { Download, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { exportCsv, exportPdf } from "@/lib/exporters";

export const ExportButtons = ({ title, columns, rows, filename, subtitle, testidPrefix }) => (
  <div className="flex gap-2">
    <Button
      variant="outline"
      size="sm"
      data-testid={`${testidPrefix}-export-csv`}
      onClick={() => exportCsv(filename, columns, rows)}
    >
      <Download className="mr-2 h-3.5 w-3.5" /> CSV
    </Button>
    <Button
      variant="outline"
      size="sm"
      data-testid={`${testidPrefix}-export-pdf`}
      onClick={() => exportPdf(title, columns, rows, subtitle)}
    >
      <FileText className="mr-2 h-3.5 w-3.5" /> PDF
    </Button>
  </div>
);
